import $ from "jquery"

// FIXME: remove dependency on jQuery in a vue project ?!

export function useJQuery() {
    return $
}